import { render } from "./comment-form-notification.vue?vue&type=template&id=596c67f9"
import script from "./comment-form-notification.vue?vue&type=script&lang=js"
export * from "./comment-form-notification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__